var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from '../message.service';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { appRenameFixed } from '../appRenameFixed';
var SurveyComponent = (function () {
    function SurveyComponent(router, apiService, messageService, commonService, route) {
        this.router = router;
        this.apiService = apiService;
        this.messageService = messageService;
        this.commonService = commonService;
        this.route = route;
        this.appRename = new appRenameFixed();
        this.isOpenClass = 0;
        this.isOnlyLearningPathCannotBack = false;
        this.assetsRoute = '../../assets';
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    SurveyComponent.prototype.onPopState = function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    };
    SurveyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        localStorage.setItem('learningPathMetaId', '0');
        $('#learningPathMetaIdContainer').val(0);
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.restart = false;
        this.clickable = true;
        this.tourSingleReport = null;
        this.userType = window.sessionStorage.getItem('userType');
        this.surveyInit();
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isOnlyLearningPathCannotBack = window.location.href.indexOf('onlyLearningPathCannotBack') !== -1;
        this.projectId = localStorage.getItem("projectId");
        this.route.queryParams.subscribe(function (params) {
            if (params.isCamp && params.isCamp === 'true') {
                _this.apiService.learingTime({ learningPathMetaId: Number(localStorage.getItem("learningPathMetaId")), module: "领导力DNA测验", type: 0, btnName: '领导力DNA', userId: localStorage.getItem('userId') }).subscribe(function (result) {
                });
            }
        });
        // console.log(this.userType);
        /*this.sceneBtnDetailShow = false;
        this.getMockSurvery();
        this.step = "begin";
    
        if(this.survey.type == 2) {
            this.sceneChangeNumber = 3;
        }else if(this.survey.type == 3){
            $("#scene_text p").text("在过去的几个月中，你的一位下属一直苦于达不到绩效目标，为了帮助他提升表现，你决定采取以下行动，请对每项行动的有效程度做出评估。");
            this.sceneChangeNumber = 3;
        }
        this.preSceneOne = "为完成一个新项目，你的下属将第一次独自带领一个跨部门项目团队，他对此不是很有经验和信心，为帮助他更好地胜任这个角色，你决定采取以下行动，请对每项行动的有效程度做出评估。";
        this.preSceneTwo = "最近一个月，你的一位下属在工作中表现不似以往那样积极主动，业绩也呈现下滑趋势，为了帮助他提升工作表现，你决定采取以下行动，请对每项行动的有效程度做出评估。";
        this.postSceneOne = "在过去的几个月中，你的一位下属一直苦于达不到绩效目标，为了帮助他提升表现，你决定采取以下行动，请对每项行动的有效程度做出评估。";
        this.postSceneTwo = "你收到来自另一个平行团队的抱怨邮件，最近你的一位下属在与他们合作时，没有积极响应对方的合作需求，提交给对方的报告也经常出现质量问题，甚至已经影响到了项目的整体进度，为改善这一状况，你决定采取以下行动，请对每项行动的有效程度做出评估。";
    
    
        this.popup = false;*/
    };
    SurveyComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: 'white'
        });
    };
    SurveyComponent.prototype.surveyInit = function () {
        var _this = this;
        var that = this;
        // console.log(that.userType);
        if (this.learningTourId == 'not') {
            this.apiService.getOrCreateSurvey(this.surveyMetaId, this.learningPathId, this.learningTourId).subscribe(function (survey) {
                _this.survey = survey;
                _this.surveyInitCallBack();
            });
        }
        else if (this.learningPathId == 'not') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/coursedna/' + this.learningTourId + '/showSurvey/' + this.surveyMetaId
            }).subscribe(function (survey) {
                _this.survey = survey[0];
                if (localStorage.getItem("source_env") == "LMS_SCORM") {
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', _this.survey.progress, "data");
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_COMPLETED', Number(_this.survey.progress) === 100.00, "data");
                }
                // console.log(this.survey);
                _this.surveyInitCallBack();
                _this.item1 = null;
                _this.item2 = null;
                _this.item3 = null;
                _this.item4 = null;
                _this.item5 = null;
                _this.item6 = null;
                _this.item7 = null;
                if (_this.survey.status != 0) {
                    _this.apiService.getDNAReport('' + _this.survey.id + '').subscribe(function (result) {
                        _this.learningTour = result;
                        //   this.learningPathMetaId = this.learningTour.learning_path_metas[0].id;
                        // });
                        console.log(_this.survey.id);
                        if (_this.survey.type == 2) {
                            _this.learningTour.details.forEach(function (item, index) {
                                if (item.ability_id == 6) {
                                    that.item4 = item;
                                    that.item4.surveyId = item.id;
                                }
                                else if (item.ability_id == 7) {
                                    that.item1 = item;
                                    that.item1.surveyId = item.id;
                                }
                                else if (item.ability_id == 8) {
                                    that.item2 = item;
                                    that.item2.surveyId = item.id;
                                }
                                else if (item.ability_id == 11) {
                                    that.item5 = item;
                                    that.item5.surveyId = item.id;
                                }
                                else if (item.ability_id == 10) {
                                    that.item3 = item;
                                    that.item3.surveyId = item.id;
                                }
                                else if (item.ability_id == 13) {
                                    that.item7 = item;
                                    that.item7.surveyId = item.id;
                                }
                                else if (item.ability_id == 12) {
                                    that.item6 = item;
                                    that.item6.surveyId = item.id;
                                }
                            });
                        }
                        else if (_this.survey.type == 3) {
                            _this.apiService.ajax({
                                'type': 'get',
                                'url': '/api/learningtour/' + _this.learningTourId + '/surveyReport/2'
                            }).subscribe(function (result2) {
                                _this.preSurveyID = result2[0].survey_id;
                                _this.apiService.getDNAReport('' + _this.preSurveyID + '').subscribe(function (result3) {
                                    _this.learningTour.details.forEach(function (item, index) {
                                        if (item.ability_id == 6) {
                                            that.item4 = item;
                                            that.item4.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 7) {
                                            that.item1 = item;
                                            that.item1.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 8) {
                                            that.item2 = item;
                                            that.item2.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 11) {
                                            that.item5 = item;
                                            that.item5.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 10) {
                                            that.item3 = item;
                                            that.item3.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 13) {
                                            that.item7 = item;
                                            that.item7.surveyId = item.id;
                                        }
                                        else if (item.ability_id == 12) {
                                            that.item6 = item;
                                            that.item6.surveyId = item.id;
                                        }
                                    });
                                    result3.details.forEach(function (item, index) {
                                        if (item.ability_id == 6) {
                                            that.item4.preLevel = item.level;
                                            that.item4.preReport = item;
                                        }
                                        else if (item.ability_id == 7) {
                                            that.item1.preLevel = item.level;
                                            that.item1.preReport = item;
                                        }
                                        else if (item.ability_id == 8) {
                                            that.item2.preLevel = item.level;
                                            that.item2.preReport = item;
                                        }
                                        else if (item.ability_id == 11) {
                                            that.item5.preLevel = item.level;
                                            that.item5.preReport = item;
                                        }
                                        else if (item.ability_id == 10) {
                                            that.item3.preLevel = item.level;
                                            that.item3.preReport = item;
                                        }
                                        else if (item.ability_id == 13) {
                                            that.item7.preLevel = item.level;
                                            that.item7.preReport = item;
                                        }
                                        else if (item.ability_id == 12) {
                                            that.item6.preLevel = item.level;
                                            that.item6.preReport = item;
                                        }
                                    });
                                });
                            });
                        }
                        else {
                        }
                    });
                }
            });
        }
    };
    SurveyComponent.prototype.surveyInitCallBack = function () {
        var _this = this;
        //进入学地图时,各能力学习时长不计时
        if (this.survey.type == 1) {
            // localStorage.setItem("learningPathMetaId","0");
            // localStorage.setItem("learningPathMetaId-moduleId","0");
            this.apiService.ajax({
                'type': 'GET',
                'url': '/sr/exposeoutapi/setAbilitySession/0/0'
            }).subscribe(function (result) {
            });
        }
        var that = this;
        var temp = 1;
        this.sceneStartAndEnd = [];
        this.sceneNames = [];
        this.sceneDescription = [];
        var questionstmp = [];
        this.survey.scenes.forEach(function (item, index) {
            questionstmp = questionstmp.concat(item.questions);
            that.sceneStartAndEnd.push({
                index: index,
                start: temp,
                end: temp + item.questions.length - 1,
                popup: false
            });
            temp += item.questions.length;
            that.sceneNames.push(item.name);
            that.sceneDescription.push(item.description);
        });
        this.survey.questions = questionstmp;
        this.selectedQuestion = this.survey.questions[0];
        this.totalNumber = this.survey.questions.length;
        this.remindTime = this.survey.remind_time;
        this.totalTime = this.survey.total_time;
        this.currentNumber = this.survey.finished_number < this.survey.questions.length ? this.survey.finished_number + 1 : this.survey.questions.length;
        this.finishedNumber = this.survey.finished_number;
        this.sceneBtnDetailShow = false;
        if (this.survey.status == 0) {
            if (!this.restart) {
                this.step = 'begin';
            }
            else {
                this.onBegin(true);
            }
        }
        else {
            this.apiService.getDNAReport('' + this.survey.id + '').subscribe(function (result) {
                _this.report = result.details[0];
                if (_this.survey.type == 1) {
                    _this.step = 'report';
                }
                else {
                    if (_this.report && _this.report.level > 0) {
                        if (_this.learningPathId == 'not') {
                            _this.step = 'tourReport';
                            // $('body').css("height", "auto");
                        }
                        else if (_this.learningTourId == 'not') {
                            _this.step = 'report';
                        }
                    }
                    else {
                        _this.showFail(_this);
                    }
                }
            });
        }
    };
    SurveyComponent.prototype.onSceneBtnClick = function () {
        this.sceneBtnDetailShow = !this.sceneBtnDetailShow;
        if (this.sceneBtnDetailShow) {
            $('#sceneBtnDetail').show();
            $('#shade2').show();
        }
        else {
            $('#sceneBtnDetail').hide();
            $('#shade2').hide();
        }
    };
    SurveyComponent.prototype.sceneDetailClose = function () {
        this.sceneBtnDetailShow = !this.sceneBtnDetailShow;
        $('#sceneBtnDetail').hide();
        $('#shade2').hide();
    };
    SurveyComponent.prototype.onSceneTextBtnClick = function () {
        $('#shade').fadeOut(500);
        $('#scene_text').animate({
            'top': '-16rem'
        }, 500, function () {
            $('#scene_text').css({
                'top': '20rem'
            });
        });
    };
    SurveyComponent.prototype.onBegin = function (begin) {
        this.step = 'survey';
        this.sceneText = this.survey.scenes[0].description;
        this.sceneBtnDetailText = this.survey.scenes[0].description;
        this.sceneBtnDetail = this.survey.scenes[0].name;
        if (this.survey.type != 1) {
            this.SwitchBg();
        }
        else {
            this.SwitchDnaBg();
        }
        this.updateUsedtime();
    };
    SurveyComponent.prototype.SwitchBg = function () {
        var _this = this;
        if ($('#scene_text').length > 0) {
            document.documentElement.style.backgroundColor = '#3f4c84';
            $('#scene_text').animate({
                'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
            });
            $('#shade').fadeIn();
            document.getElementById('shade').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('scene_text').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('scene_text_btn').ontouchmove = function (e) {
                e.preventDefault();
            };
        }
        else {
            setTimeout(function () {
                _this.SwitchBg();
            }, 100);
        }
    };
    SurveyComponent.prototype.SwitchDnaBg = function () {
        var _this = this;
        if ($('#questionWrap').length > 0) {
            document.documentElement.style.backgroundColor = '#3f4c84';
        }
        else {
            setTimeout(function () {
                _this.SwitchDnaBg();
            }, 100);
        }
    };
    SurveyComponent.prototype.onRestart = function (restart) {
        var _this = this;
        this.restart = true;
        this.apiService.tickReset('0').subscribe(function () {
            _this.apiService.resetDNASurvey('' + _this.survey.id + '').subscribe(function (data) {
                _this.tickTimeData = null; //重置倒计时信息
                _this.surveyInit();
                // if(this.commonService.getStorage('tourId')){
                //   this.step = 'begin';
                // }
            });
        });
        document.documentElement.style.backgroundColor = '#3f4c84';
    };
    SurveyComponent.prototype.onContinue = function (begin) {
        this.step = 'survey';
        document.documentElement.style.backgroundColor = '#3f4c84';
        if (this.survey.finished_number < this.survey.questions.length) {
            this.currentNumber = this.survey.finished_number + 1;
        }
        else {
            this.currentNumber = this.survey.questions.length;
        }
        if (this.survey.type != 1) {
            var index = this.getSceneByQuestion(this.currentNumber, this.sceneStartAndEnd);
            this.sceneText = this.sceneDescription[index];
            this.sceneBtnDetailText = this.sceneDescription[index];
            this.sceneBtnDetail = this.sceneNames[index];
        }
        if (this.survey.type != 1) {
            setTimeout(function () {
                $('#scene_text').animate({
                    'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
                });
                $('#shade').fadeIn();
                document.getElementById('shade').ontouchmove = function (e) {
                    e.preventDefault();
                };
                document.getElementById('scene_text').ontouchmove = function (e) {
                    e.preventDefault();
                };
                document.getElementById('scene_text_btn').ontouchmove = function (e) {
                    e.preventDefault();
                };
            }, 100);
        }
        this.selectedQuestion = this.survey.questions[this.currentNumber - 1];
        this.updateUsedtime();
    };
    SurveyComponent.prototype.setClickAble = function (event) {
        this.clickable = event;
    };
    SurveyComponent.prototype.onAnswer = function (optionId) {
        var _this = this;
        var that = this;
        if (this.clickable) {
            this.clickable = false;
        }
        this.apiService.answerQuestion('' + this.survey.id + '', this.selectedQuestion.id, optionId).subscribe(function (survey) {
            setTimeout(function () {
                if (that.currentNumber < that.survey.questions.length) {
                    if (that.currentNumber > that.finishedNumber) {
                        that.finishedNumber++;
                    }
                    that.currentNumber++;
                    if (that.matchSceneChangeNumbers(that.currentNumber, that.sceneStartAndEnd) && that.survey.type != 1) {
                        var object = that.matchSceneChangeNumbers(that.currentNumber, that.sceneStartAndEnd);
                        $('#sceneBtn').text(that.sceneNames[object.index]);
                        $('#scene_text p').text(that.sceneDescription[object.index]);
                        $('#sceneBtnDetailText').html(that.sceneDescription[object.index]);
                        if (!object.popup) {
                            that.sceneStartAndEnd[object.index].popup = true;
                            $('#scene_text').animate({
                                'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
                            });
                            $('#shade').fadeIn();
                            document.getElementById('shade').ontouchmove = function (e) {
                                e.preventDefault();
                            };
                            document.getElementById('scene_text').ontouchmove = function (e) {
                                e.preventDefault();
                            };
                            document.getElementById('scene_text_btn').ontouchmove = function (e) {
                                e.preventDefault();
                            };
                        }
                    }
                    that.selectedQuestion = that.survey.questions[that.currentNumber - 1];
                }
                else {
                    $('#submit_circle').fadeIn(500);
                }
            }, 500);
        }, function (error) {
            _this.clickable = false;
        });
    };
    SurveyComponent.prototype.onSlide = function (index) {
        if (index < 0 && this.currentNumber <= this.finishedNumber && this.currentNumber < this.survey.questions.length) {
            this.currentNumber++;
            this.selectedQuestion = this.survey.questions[this.currentNumber - 1];
        }
        else if (index > 0 && this.currentNumber > 1) {
            this.currentNumber--;
            this.selectedQuestion = this.survey.questions[this.currentNumber - 1];
        }
        if (this.survey.type != 1) {
            var index_1 = this.getSceneByQuestion(this.currentNumber, this.sceneStartAndEnd);
            $('#scene_text p').text(this.sceneDescription[index_1]);
            $('#sceneBtnDetailText').html(this.sceneDescription[index_1]);
            $('#sceneBtn').text(this.sceneNames[index_1]);
        }
    };
    SurveyComponent.prototype.onTimeout = function () {
        $('#tip2').fadeIn(500);
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        var that = this;
        if (this.survey.type == 1) {
            setTimeout(this.showFail, 2000, this);
        }
        else {
            if (this.finishedNumber == 0) {
                if (this.survey.type == 2) {
                    setTimeout(function () {
                        that.apiService.finishSurvey('' + that.survey.id + '', '' + that.survey.type + '').subscribe(function (survey) {
                            that.showFail(that);
                        });
                    }, 2000);
                }
                else if (this.survey.type == 3) {
                    setTimeout(function () {
                        that.apiService.finishSurvey('' + that.survey.id + '', '' + that.survey.type + '').subscribe(function (survey) {
                            that.showPostSurveyTip();
                        });
                    }, 2000);
                }
                /*setTimeout(this.showFail,2000, this);*/
            }
            else {
                if (this.survey.type == 2) {
                    setTimeout(function () {
                        that.apiService.finishSurvey('' + that.survey.id + '', '' + that.survey.type + '').subscribe(function (survey) {
                            that.step = 'report';
                        });
                    }, 2000);
                }
                else if (this.survey.type == 3 && this.learningPathId !== '0') {
                    setTimeout(function () {
                        that.apiService.finishSurvey('' + that.survey.id + '', '' + that.survey.type + '').subscribe(function (survey) {
                            that.showPostSurveyTip();
                        });
                    }, 2000);
                }
            }
        }
    };
    SurveyComponent.prototype.showFail = function (targetObj) {
        $('#tip2').fadeOut(500);
        targetObj.step = 'fail';
        if (this.survey && this.survey.type == 1) {
            targetObj.apiService.resetSurvey('' + targetObj.survey.id + '').subscribe(function (data) {
            });
        }
    };
    SurveyComponent.prototype.onTimeReminder = function () {
        $('#tip1').fadeIn(500);
        setTimeout(function () {
            $('#tip1').fadeOut(500);
        }, 2000);
    };
    SurveyComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.learningTourId == 'not') {
            this.apiService.finishSurvey('' + this.survey.id + '', '' + this.survey.type + '').subscribe(function (survey) {
                if (_this.intervalId) {
                    clearInterval(_this.intervalId);
                }
                if (_this.survey.type == 3 && _this.learningPathId !== '0') {
                    _this.showPostSurveyTip();
                }
                else {
                    _this.step = 'report';
                }
            });
        }
        else if (this.learningPathId == 'not') {
            this.apiService.finishSurvey('' + this.survey.id + '', '' + this.survey.type + '').subscribe(function (result) {
                if (localStorage.getItem("source_env") == "LMS_SCORM") {
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', 100, "data");
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_COMPLETED', true, "data");
                }
                if (_this.intervalId) {
                    clearInterval(_this.intervalId);
                }
                // post survey
                if (_this.survey.type == 3 && _this.learningPathId !== '0') {
                    // this.showPostSurveyTip();
                    _this.step = 'tourReport';
                    // $('body').css("height", "auto");
                    _this.surveyInit();
                    document.documentElement.style.backgroundColor = 'white';
                }
                else {
                    _this.step = 'tourReport';
                    // $('body').css("height", "auto");
                    _this.surveyInit();
                    document.documentElement.style.backgroundColor = 'white';
                }
            });
        }
    };
    SurveyComponent.prototype.linkToTourReport = function (item) {
        this.tourSingleReport = item;
        this.step = 'report';
    };
    SurveyComponent.prototype.directToGraduation = function (firstEntry) {
        var link = ['graduation', this.learningPathId, 0, firstEntry ? 1 : 0];
        this.router.navigate(link);
    };
    SurveyComponent.prototype.showPostSurveyTip = function () {
        var _this = this;
        if (this.learningTourId == 'not') {
            this.apiService.getGraduationByLearningPathId('' + this.learningPathId + '', '' + '0' + '').subscribe(function (graduation) {
                _this.graduation = graduation;
                if (_this.graduation.postSurveyLevel == '0') {
                    _this.showFail(_this);
                }
                else {
                    /*let link = ['post-ability-test-tip', this.graduation.postSurveyLevel,this.learningPathId];
                    this.router.navigate(link);*/
                    _this.step = 'report';
                }
            });
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningtour/' + this.learningTourId + '/graduation/0',
                'data': {}
            }).subscribe(function (result) {
                if (result.postSurveyReports[0].coaching == '0') {
                    _this.showFail(_this);
                }
                else {
                    /*let link = ['post-ability-test-tip', result.postSurveyReports[0].coaching,0];
                    this.router.navigate(link);*/
                    _this.step = 'tourReport';
                    // $('body').css("height", "auto");
                    _this.surveyInit();
                    document.documentElement.style.backgroundColor = 'white';
                }
            });
        }
    };
    SurveyComponent.prototype.updateUsedtime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, survey, apiService, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        that = this;
                        survey = that.survey;
                        console.log('survey', survey);
                        apiService = that.apiService;
                        //获取tick
                        console.log("tickTimeData", that.tickTimeData);
                        if (!(!that.tickTimeData || !that.tickTimeData.id)) return [3 /*break*/, 2];
                        _a = that;
                        return [4 /*yield*/, that.getTickInit()];
                    case 1:
                        _a.tickTimeData = _b.sent();
                        console.log("tickTimeData", that.tickTimeData);
                        if (that.tickTimeData.usedTime >= that.survey.total_time) {
                            return [2 /*return*/]; //如果已经超时，不走倒计时接口了
                        }
                        _b.label = 2;
                    case 2:
                        that.intervalId = setInterval(function () {
                            console.log('开始调用倒计时接口');
                            // var usedTime = survey.used_time;
                            apiService.tickUpdateSurveyTime('' + that.tickTimeData.tickId + '').subscribe(function (data) {
                                console.log('倒计时调用成功：', data);
                            });
                        }, 1000);
                        return [2 /*return*/];
                }
            });
        });
    };
    SurveyComponent.prototype.getTickInit = function () {
        return this.apiService.tickInit('0').toPromise();
    };
    SurveyComponent.prototype.exit = function () {
        var _this = this;
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        if (this.learningPathId == 'not') {
            var projectId = localStorage.getItem("projectId");
            var link = ['learning-map'];
            if (projectId) {
                link = ['learning-project', projectId];
            }
            this.router.navigate(link);
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
            }).subscribe(function (result) {
                // if(this.projectId && this.projectId.trim() != ''){
                //   localStorage.removeItem("projectmsg")
                //   let link = ['learning-project-path', result.data];
                //   this.router.navigate(link,{
                //     queryParams:{
                //       projectId: this.projectId
                //     }
                //   });
                // }else{
                var link = ['learning-path', result.data];
                _this.router.navigate(link);
                // }
            });
        }
    };
    SurveyComponent.prototype.close = function () {
        $('#shade').fadeIn();
        $('#tip3').fadeIn();
        document.getElementById('tip3').ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById('tip3Text').ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById('quitBtn').ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById('continueBtn').ontouchmove = function (e) {
            e.preventDefault();
        };
    };
    SurveyComponent.prototype.goBackSurvey = function () {
        this.step = 'tourReport';
        // $('body').css("height", "auto");
    };
    SurveyComponent.prototype.continue = function () {
        $('#shade').fadeOut();
        $('#tip3').fadeOut();
    };
    SurveyComponent.prototype.matchSceneChangeNumbers = function (num, object) {
        for (var i = 0; i < object.length; i++) {
            if (object[i].start == num) {
                return object[i];
            }
            else {
                continue;
            }
        }
        return false;
    };
    SurveyComponent.prototype.getSceneByQuestion = function (num, object) {
        for (var i = 0; i < object.length; i++) {
            if (num >= object[i].start && num <= object[i].end) {
                return object[i].index;
            }
        }
    };
    return SurveyComponent;
}());
export { SurveyComponent };



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.ts.pre-build-optimizer.js